import { TRole } from '../types/role.type';

const ADMIN_ROLE = 'admin' as TRole['name'];
const AGENT_ROLE = 'agent' as TRole['name'];
const MENTOR_ROLE = 'mentor' as TRole['name'];
const SUPERVISOR_ROLE = 'supervisor' as TRole['name'];
const TICKETING_ADMIN_ROLE = 'ticketing-admin' as TRole['name'];
const TICKETING_MEMBER_ROLE = 'ticketing-member' as TRole['name'];

const TICKETING_ROLES = [TICKETING_ADMIN_ROLE, TICKETING_MEMBER_ROLE] as TRole['name'][];
const NL_CARE_ROLES = [AGENT_ROLE, MENTOR_ROLE, SUPERVISOR_ROLE, ADMIN_ROLE] as TRole['name'][];
const ALL_ROLES = [...TICKETING_ROLES, ...NL_CARE_ROLES] as TRole['name'][];
const NO_ROLES = [] as TRole['name'][];

export {
  ADMIN_ROLE,
  AGENT_ROLE,
  MENTOR_ROLE,
  SUPERVISOR_ROLE,
  TICKETING_ADMIN_ROLE,
  TICKETING_MEMBER_ROLE,
  TICKETING_ROLES,
  NL_CARE_ROLES,
  ALL_ROLES,
  NO_ROLES,
};
